import { createStore } from 'vuex'
import modules from '../modules/autoLoader'
export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {}, 
    modules: modules
})